function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

// The role of this function is to trap focus on elements that are being focused by tabs
// within a certain container.
// ie. When a cart drawer opens, the tab cycles only within the focusable elements within the cart drawer.
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.input.addEventListener("change", this.onInputChange.bind(this));

    this.debouncedOnClick = this.onButtonClick;

    this.debouncedUpdatedProductQuantity = debounce((value) => {
      this.updateProductQunatity(value);
    }, 200);

    // debounce((event) => {

    // }, 200);

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.debouncedOnClick.bind(this))
    });

    document.addEventListener("update--bubble-sticky-menu", () => {
      this.updateBubbleIcon();
    });

    this.varaintId = this.getAttribute("data-vid");

    document.addEventListener(`update-quantity--${this.varaintId}`, (event) => {
      // console.log(this);
      const parentElement = this.closest('.product-form__buttons');

      // if (parentElement) {
      //   const minusButton = parentElement.querySelector("[name='minus']");
      //   if (minusButton) {
      //     if ( event.detail.quantity <= 1 ) {
      //       minusButton.disabled === true
      //     } else {
      //       minusButton.disabled === false
      //     }
      //   }
      // }

      if (event.detail.quantity !== 0) {
        this.input.value = event.detail.quantity;
      } else {
        const mmCard = this?.closest("marmeto-product-card");
        const productForm = mmCard?.querySelector("product-form");
        if (productForm) {
          productForm.classList.remove("hidden");
        }
        this.classList.add("hidden");
      }
    });

   document.addEventListener(`remove-product--${this.varaintId}`, (event) => {
       if (event.detail.quantity === 0) {
        this.input.value = 1;
      }
        const mmCard = this?.closest("marmeto-product-card");
        if(mmCard) {
        const productForm = mmCard.querySelector("product-form");
        if (productForm) {
          productForm.classList.remove("hidden");
        }
        this.classList.add("hidden");
      } else {
        const parentElement = this.closest('.product-form__buttons');
        if(parentElement === null) return;
        parentElement.querySelector('quantity-input').classList.add('hidden');
        parentElement.querySelector('button').classList.remove('hidden');

      }
    });

    this.controller = new AbortController();
    this.signal = this.controller.signal;
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    
    console.log(event);
    const previousValue = this.input.value;
    const closeToDeleteButton = event.target.closest('.cart-item__bottom-row')?.querySelector('cart-remove-button button');

    console.log(closeToDeleteButton);

    if(event.target.name != "delete") {
      event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    }


    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    if (!event.target.closest("cart-drawer-items")) {
      this.controller.abort();
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.debouncedUpdatedProductQuantity(this.input.value)
    }

    // Hack click in the cart drawer when minus is clicked
    if(
      event.target.name === "delete" &&
      this.input.value == 1 &&
      closeToDeleteButton
    ) {
      closeToDeleteButton.click();
    }

    if (
      event.target.name === "minus" &&
      this.input.value == 0 &&
      !this.closest("marmeto-product-card")
    ) {
      this.classList.add("hidden");
      this.input.value = 1;
      // if (this.previousElementSibling) {
        this.previousElementSibling.classList.remove("hidden");
      // }
    }

    if (this.input.value == 0 && this.closest("marmeto-product-card")) {
      this.classList.add("hidden");
      this.input.value = 1;
      // if (this.previousElementSibling) {
        this.previousElementSibling.classList.remove("hidden");
      // }
    }
  }

  updateProductQunatity(newQuantity) {
    try {
      const variantId =
        this?.closest("marmeto-product-card")?.id ||
        this.getAttribute("data-vid");
      const data = {
        id: variantId,
        quantity: newQuantity,
      };


      // Make a fetch request to update the cart
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        signal: this.signal,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((response) => {
          this.refreshCart();
          this.updateBubbleIcon(true);

        })
        .catch(function (error) {
          console.error("Error:", error);
          // Handle the error here, e.g., display an error message to the user
        });
    } catch (error) {
      console.error("An error occurred:", error);
      // Handle the error here, e.g., display an error message to the user
    }
  }

  // this will update cart drawer , when the qunatity is changed from product card only
  refreshCart() {
    const sectionId = this.cart.dataset.sectionId;
    fetch(`/cart`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const cartDrawerContent = html.querySelector("#CartDrawer");
        if (cartDrawerContent) {
          document.querySelector("#CartDrawer").innerHTML =
            cartDrawerContent.innerHTML;
          if (!document.querySelector("#CartDrawer-Checkout")) {
            document.querySelector("cart-drawer").classList.add("is-empty");
          }
          const productCardId =
            this.closest("product-form")?.getAttribute("pid");
          const clickedSectionId = this.getAttribute("sid");

          if (productCardId) {
            const event = new CustomEvent(`update-card--${productCardId}`, {
              detail: {
                sectionId: clickedSectionId,
                currentQuantity: this.presentQuantity,
              },
            });

            document.dispatchEvent(event);
          }

          if (
            this.closest("main-product-button") &&
            this.presentQuantity == 0
          ) {
            const productId = this.closest("main-product-button").dataset.id;
            const event = new Event(`main-product--${productId}`);
            document.dispatchEvent(event);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateBubbleIcon(update) {
    fetch("/?section=sticky-header")
      .then((res) => res.text())
      .then((responseText) => {
        const stickmenuHtml = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );

        // Other cart icon with bubbles in the page.
        const cartLinks = Array.from(document.querySelectorAll(".cart-icon-bubble"));

        if (update) {
          document.querySelector("#cart-icon-bubble").innerHTML =
            stickmenuHtml.querySelector("#cart-icon-bubble").innerHTML;

          cartLinks.forEach((cartLink) => {
            cartLink.innerHTML = stickmenuHtml.querySelector("#cart-icon-bubble").innerHTML;
          });


          window.initCollectionProgess && window.initCollectionProgess();

        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderFirstItemNode =
      this.querySelector("li.product__media-item") ||
      this.querySelector("ul .slider__slide");

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

    this.sliderControlLinksArray = Array.from(
      this.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector(".announcement-bar-slider")) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia("(min-width: 750px)");
      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener("change", () => {
          if (this.slider.getAttribute("data-autoplay") === "true")
            this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches ||
      this.announcementBarArrowButtonWasClicked ||
      !this.desktopLayout.matches
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (
      this.querySelector(".announcement-bar-slider").contains(event.target)
    ) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }


    window.updateBundleSelection && window.updateBundleSelection();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );

    // console.log('cdebug ${this.dataset.section}-${this.currentVariant.featured_media.id}', `${this.dataset.section}-${this.currentVariant.featured_media.id}`)

    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Custom JS
// Marmeto Product Card

class MarmetoProductCard extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.addEventListener("change", (event) => {
      if (event.target.name == "id") this.variantChange();
    });

    document.addEventListener("headerIconFilter", (event) => {
      if (this.dataset.headerFilter.includes(event.detail.filter)) {
        this.parentNode.classList.remove("hidden");
      } else {
        this.parentNode.classList.add("hidden");
      }
    });
  }
}
customElements.define("marmeto-product-card", MarmetoProductCard);

class MMvariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#mm-product-form--${this.dataset.pid}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `mm-product-form--${this.dataset.pid}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `mm-product-form--${this.dataset.pid}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.pid}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("mm-variant-selects", MMvariantSelects);

class MMvariantRadios extends MMvariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

if (!customElements.get("carousel-component")) {
  class Carousel extends HTMLElement {
    constructor() {
      super();
      this.carouselElement = this;

      // Carousel element should have class splide
      if (!this.carouselElement.classList.contains("splide")) return;
      this.desktopPerPage = this.carouselElement.dataset["desktopperpage"] || 4;
      this.mobilePerPage = this.carouselElement.dataset["mobileperpage"] || 1;
      this.focus = this.carouselElement.dataset["focus"] || "center";
      this.type = this.carouselElement.dataset["type"] || "loop";
      this.gap = this.carouselElement.dataset["gapbetweenslides"] || 20;
      this.mobilegap =
        this.carouselElement.dataset["mobilegapbetweenslides"] || 0;
      this.autoplaySpeed = parseInt(this.dataset["autoplaySpeed"]) || 3000;
      this.direction = this.carouselElement.dataset["direction"] || "ltr";

      // Data attribute string matching for correct boolean value
      // The fallback is used if the developer make mistake the code is forgiving
      // Read more here https://stackoverflow.com/questions/263965/how-can-i-convert-a-string-to-boolean-in-javascript
      this.showarrows =
        this.carouselElement.dataset["showarrows"] === "true" || false;
      this.autoplay =
        this.carouselElement.dataset["autoplay"] === "true" || false;
      this.showarrowsonmobile =
        this.carouselElement.dataset["showarrowsonmobile"] === "true" || false;
      this.showdots =
        this.carouselElement.dataset["pagination"] === "true" || false;
      this.showdotsonmobile =
        this.carouselElement.dataset["showdotsonmobile"] === "true" || false;
      this.isNavigation =
        this.carouselElement.dataset["isnavigation"] === "true" || false;
      this.disableDrag =
        this.carouselElement.dataset["disabledrag"] === "true" || false;

      this.sync = this.carouselElement.dataset["carouselsyncselector"] || false;

      this.initCarousel();
    }

    initCarousel() {
      // More option available here https://splidejs.com/documents/
      // This slider can be customized as require check the above doc before adding any new
      // Slider library.

      this.carousel = new Splide(this.carouselElement, {
        perPage: this.desktopPerPage,
        type: this.type,
        focus: this.focus,
        autoplay: this.autoplay,
        interval: this.autoplaySpeed,
        gap: parseInt(this.gap),
        arrows: this.showarrows,
        pagination: this.showdots,
        isNavigation: this.isNavigation,
        drag: !this.disableDrag,
        direction: this.direction,
        breakpoints: {
          767: {
            perPage: this.mobilePerPage,
            arrows: this.showarrowsonmobile,
            pagination: this.showdotsonmobile,
            gap: parseInt(this.mobilegap),
          },
        },
      });

      if (this.sync) {
        this.initCarouselSync();
      } else {
        this.carousel.mount();
        // this.limitButtonScroll();
      }
    }

    initCarouselSync() {
      this.syncElement = document.querySelector(this.sync);
      this.direction = this.syncElement.dataset["direction"] || "ltr";

      this.carouselSync = new Splide(this.sync, {
        updateOnMove: true,
        perPage: this.syncElement.dataset["desktopperpage"] || 5,
        type: this.syncElement.dataset["type"] || "loop",
        focus: this.syncElement.dataset["focus"] || "center",
        isNavigation:
          this.syncElement.dataset["isnavigation"] === "true" || false,
        pagination: false,
        arrows: this.syncElement.dataset["showarrows"] === "true" || false,
        drag: true,
        // Conditional configuration for 'ttb' direction
        ...(this.direction === "ttb" && {
          height: this.getPrimarySlideFirstImageHeight(),
          direction: "ttb",
          autoHeight: true,
        }),
        breakpoints: {
          767: {
            height: "auto",
            direction: "ltr",
          },
        },
      });

      this.carousel.sync(this.carouselSync);
      this.carousel.mount();
      this.carouselSync.mount();
    }

    refreshSlider() {
      this.carousel.refresh();
      if (this.carouselSync) {
        this.carouselSync.refresh();
      }
    }

    getPrimarySlideFirstImageHeight() {
      const image = this.querySelector(".splide__list img");
      const containerWidth = this.querySelector(".splide__list").clientWidth;

      // Get the original width and height of the image
      const originalWidth = image.getAttribute("width");
      const originalHeight = image.getAttribute("height");

      // Calculate the scaled height to fit within the container
      return (containerWidth / originalWidth) * originalHeight;
    }

    limitButtonScroll() {
    const nextButton = this.carouselElement.querySelector('.splide__arrow.splide__arrow--next');
    nextButton.addEventListener('click', (event) => {
      const carouselIndex = this.carousel.index;
      const carouselEndPoint= this.carousel.length - 9;   // value 9 has to the splide items on the viewport
      console.log('index', carouselIndex);
      if ( carouselIndex >= carouselEndPoint ) {
        debugger;
        nextButton.disabled = true;
        event.preventDefault();
        nextButton.classList.add('disable-button');
      }
    });
    }

  }

  // Exposing the Carousel class globally to allow other custom elements, like the product-form, to extend its functionality.
  window.Carousel = Carousel;
  customElements.define("carousel-component", Carousel);
}

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    addCartNote && addCartNote();
    initCollectionProgess();

    const progress = this.dataset.progress;
    if(progress === '') return
    const prevProgress = sessionStorage.getItem("progress");
    if (prevProgress != null) {
      this.querySelector(".max-bar-wrapper .scroll-bar").style.width =
        prevProgress + "%";
    }
    this.expandProgressBar(progress);
  }
  //this will increase the widht of progress bar in cart page
  expandProgressBar(progress) {
    const maxBarWrapper = this.querySelector(".max-bar-wrapper .scroll-bar");
    setTimeout(() => {
      maxBarWrapper.style.width = progress + "%";
    });
    sessionStorage.setItem("progress", progress);
  }
}

customElements.define("progress-bar", ProgressBar);

document.addEventListener("DOMContentLoaded", function () {
  initCollectionProgess();
});

// this will add progessbar in collection page and also add transition to it and cart drawer open functionality on button click

function initCollectionProgess() {
  const container = document.querySelector(".collection-progress-bar");
  if (container) {
    const collectionProgressBar = container.querySelector(
      " .collection-progess-update"
    );
    if (collectionProgressBar) {
      const cartProgressBar = document.querySelector(
        ".cart-drawer__footer progress-bar"
      );
      collectionProgressBar.innerHTML = cartProgressBar.innerHTML;
      const prevProgress = sessionStorage.getItem("progress");
      const progress = document.querySelector("progress-bar").dataset.progress;
      if (progress !== "") {
        if (prevProgress != null) {
          container.querySelector(".max-bar-wrapper .scroll-bar").style.width =
            prevProgress + "%";
        }
        //this will increase the widht of progress bar in collection page
        const maxBarWrapper = container.querySelector(
          ".max-bar-wrapper .scroll-bar"
        );

        setTimeout(() => {
          maxBarWrapper.style.width = progress + "%";
        });
        sessionStorage.setItem("progress", progress);
      }
      document.querySelector(".collection-progess-update + button").innerHTML =
        document.querySelector(
          "cart-drawer progress-bar .collection-cart-data"
        ).innerHTML;
      //cart drawer will open on button click
      const progressButton = document.querySelector(
        ".collection-progess-update + button"
      );
      progressButton?.addEventListener("click", () => {
        document.querySelector("cart-drawer").open();
      });
    }
  }
}

window.initCollectionProgess = initCollectionProgess;

window.onload = () => {
  if (window.location.href.includes("collections"))
    localStorage.setItem("prevPage", window.location.href);

  console.log(localStorage.getItem("prevPage"));
};

class CheckoutButton extends HTMLElement {
  constructor() {
    super();

  }
  connectedCallback() {
    // data-min-cost / data-cart-cost are in cents; checkout is gated by order total
    const minCostAttr = this.getAttribute("data-min-cost");
    const discountCodesBypass = this.getAttribute('data-cart-discount-bypass');
    const checkoutButton = this.querySelector("button");

    if (minCostAttr) {
      const minCost = parseInt(minCostAttr) || 0;
      const cartCost = parseInt(this.getAttribute("data-cart-cost")) || 0;

      if (cartCost < minCost) {
        checkoutButton.setAttribute("disabled", "");
      }

      if(discountCodesBypass == "true") {
        checkoutButton.removeAttribute("disabled");
      }
    }

    checkoutButton.addEventListener('click', this.onButtonSubmit.bind(this))
  }

  disconnectedCallback() {
    const checkoutButton = this.querySelector("button");


    checkoutButton.removeEventListener('click', this.onButtonSubmit)
  }

  toggleButtonLoadingState() {
    const checkoutButton = this.querySelector("button");
    const loader = this.querySelector(".loader");

    console.log('cdebug', checkoutButton.disabled);
    console.log('cdebug', loader);

    if(checkoutButton.disabled) {
      checkoutButton.removeAttribute('disabled');
      loader.classList.add('hidden');
    } else {
      checkoutButton.setAttribute('disabled', "true");
      loader.classList.remove('hidden');
    }

  }

  async updateLineItemsQty(updates = {}) {
    let response;

    if(Object.keys(updates).length > 0) {

      try {
        response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        });

        console.log('cdebug', response.json());

      } catch(e) {
        console.log('cdebug updateLineItemQty Error', e, lineItemsForUpdate);
      }

      if(response.status == 200) {
        return Promise.resolve(true);
      }

    }

    return Promise.resolve(false);
  }

  onButtonSubmit(e) {
    e.preventDefault();

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer?._isCalculatingTotals) {
      return;
    }

    // Defer delivery-frequency selection to the modal. The modal validates the
    // choice, applies it across the cart, then submits the checkout form.
    const modal = document.querySelector('delivery-frequency-modal');
    if (modal && typeof modal.open === 'function') {
      modal.open(this.querySelector('button'));
      return;
    }

    document.querySelector('#CartDrawer-Form')?.submit();
  }
}

customElements.define("checkout-button", CheckoutButton);

class DeliveryFrequencyModal extends HTMLElement {
  static SUBSCRIPTION_SAVE_PERCENT = 5;

  constructor() {
    super();
    this.onKeydown = this.onKeydown.bind(this);
    this.onPageShow = this.onPageShow.bind(this);
    this._pricingRequestId = 0;
    this._isPricingLoading = false;
    this._isPricingReady = false;
    this._pricingCache = null;
    this._pricingPromise = null;
    this._pricingPrefetchTimer = null;
  }

  connectedCallback() {
    this.dialog = this.querySelector('.df-modal__dialog');
    this.optionEls = Array.from(this.querySelectorAll('.df-option'));
    this.confirmButton = this.querySelector('.df-modal__confirm');
    this.confirmLabel = this.querySelector('.df-modal__confirm-label');
    this.errorEl = this.querySelector('.df-modal__error');
    this._defaultConfirmLabel =
      this.confirmLabel?.textContent?.trim() || 'Checkout';

    this.querySelectorAll('[data-df-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );

    this.addEventListener('change', (e) => {
      if (e.target && e.target.name === 'df_purchase_option') this.onSelectionChange();
    });

    this.confirmButton?.addEventListener('click', () => this.onConfirm());

    // When the page is restored from the browser's back/forward cache (e.g. the
    // customer clicked "Checkout", landed on the checkout page, then hit Back),
    // the confirm button's frozen disabled/loading state comes back with it.
    // Reset it on pageshow so the modal is interactive again.
    window.addEventListener('pageshow', this.onPageShow);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this._cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this.schedulePricingPrefetch();
      });
    }

    this.schedulePricingPrefetch(50);
  }

  disconnectedCallback() {
    window.removeEventListener('pageshow', this.onPageShow);
    this._cartUpdateUnsubscriber?.();
    window.clearTimeout(this._pricingPrefetchTimer);
  }

  onPageShow(event) {
    if (event.persisted) {
      this.setUpdatingGuard(false);
      this.setConfirmLoading(false);
      this._isPricingLoading = false;
      this._isPricingReady = true;
      this.syncConfirmButtonState();
    }
  }

  normalize(value) {
    return (value || '').toLowerCase().trim();
  }

  getOneOffTotalCents() {
    return parseInt(this.getAttribute('data-cart-total'), 10) || 0;
  }

  /**
   * One-off total must come from the live cart — data-cart-total on the modal is
   * NOT refreshed by renderContents() (modal sits outside #CartDrawer).
   */
  async resolveOneOffTotalCents() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        const cart = await response.json();
        if (cart?.total_price != null) {
          const hasSubscription = (cart.items || []).some(
            (item) => !!item.selling_plan_allocation?.selling_plan?.id
          );
          // If subscription plans are still on the cart, prefer original/subtotal
          // so One-off doesn't inherit subscription discounts.
          const cents = hasSubscription
            ? cart.original_total_price ?? cart.items_subtotal_price ?? cart.total_price
            : cart.total_price;
          this.setAttribute('data-cart-total', String(cents));
          return cents;
        }
      }
    } catch (err) {
      console.warn('resolveOneOffTotalCents cart.js error', err);
    }

    // Fallback: checkout-button is inside #CartDrawer and updates with each re-render.
    const liveCartCost = document
      .querySelector('checkout-button')
      ?.getAttribute('data-cart-cost');
    if (liveCartCost != null && liveCartCost !== '') {
      const cents = parseInt(liveCartCost, 10) || 0;
      this.setAttribute('data-cart-total', String(cents));
      return cents;
    }

    return this.getOneOffTotalCents();
  }

  formatMoney(cents) {
    let formatted = '';

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      const format = this.getAttribute('data-money-format') || undefined;
      formatted = Shopify.formatMoney(cents, format);
    } else {
      const amount = (Number(cents) || 0) / 100;
      try {
        formatted = new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: 'AUD',
          currencyDisplay: 'narrowSymbol',
        }).format(amount);
      } catch (err) {
        formatted = `$${amount.toFixed(2)}`;
      }
    }

    // Drop currency letter prefixes (e.g. A$ -> $)
    return String(formatted).replace(/^[A-Z]{1,3}\s?(?=\$)/i, '').trim();
  }

  open(trigger) {
    this.trigger = trigger || null;
    this.setError('');
    this.resetSelection();
    this.computeAvailability();
    this.selectDefaultFrequency();

    // Estimate-only pricing (fixed 5% off one-off total). Do NOT mutate the cart
    // here — clearing plans mid-open caused partial Weekly labels + spinner.
    this._pricingCache = null;
    const hasImmediatePricing = this.applyImmediateEstimatedPricing();

    if (hasImmediatePricing) {
      this.setPricingLoading(false);
    } else {
      this.clearOptionPrices();
      this.setPricingLoading(true);
      this.startPricingLoad();
    }

    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', this.onKeydown);

    // Trap keyboard focus within the dialog, starting on the first usable option.
    const firstEnabled = this.optionEls.find((el) => !el.classList.contains('is-unavailable'));
    const focusTarget = firstEnabled?.querySelector('input') || this.dialog;
    if (typeof trapFocus === 'function') {
      trapFocus(this.dialog, focusTarget);
    } else {
      window.setTimeout(() => focusTarget?.focus(), 50);
    }
  }

  close() {
    if (this._isUpdatingFrequency) return;

    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', this.onKeydown);
    this.setUpdatingGuard(false);
    this.setConfirmLoading(false);
    this._pricingRequestId += 1;
    this._isPricingLoading = false;
    this._isPricingReady = false;
    this.classList.remove('is-pricing');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.trigger);
    } else {
      this.trigger?.focus();
    }
  }

  onKeydown(e) {
    if (e.key === 'Escape') {
      if (this._isUpdatingFrequency) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      this.close();
    }
  }

  /**
   * UI-only lock while selling plans are applied. Does not change apply logic.
   */
  setUpdatingGuard(isUpdating) {
    this._isUpdatingFrequency = !!isUpdating;
    this.classList.toggle('is-updating', isUpdating);

    const guard = this.querySelector('.df-modal__updating-guard');
    if (guard) {
      guard.hidden = !isUpdating;
      guard.setAttribute('aria-hidden', isUpdating ? 'false' : 'true');
    }

    this.querySelectorAll('[data-df-close]').forEach((el) => {
      if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
        el.disabled = isUpdating;
      } else {
        el.style.pointerEvents = isUpdating ? 'none' : '';
      }
    });

    this.querySelectorAll('input[name="df_purchase_option"]').forEach((input) => {
      if (isUpdating) {
        if (!input.dataset.dfWasDisabled) {
          input.dataset.dfWasDisabled = input.disabled ? '1' : '0';
        }
        input.disabled = true;
      } else if (input.dataset.dfWasDisabled != null) {
        input.disabled = input.dataset.dfWasDisabled === '1';
        delete input.dataset.dfWasDisabled;
      }
    });
  }

  resetSelection() {
    this.querySelectorAll('input[name="df_purchase_option"]').forEach((input) => {
      input.checked = false;
    });
    if (this.confirmButton) this.confirmButton.disabled = true;
  }

  selectDefaultFrequency() {
    const weeklyOption = this.optionEls[0];
    const defaultOption =
      weeklyOption && !weeklyOption.classList.contains('is-unavailable')
        ? weeklyOption
        : this.optionEls.find((el) => !el.classList.contains('is-unavailable'));

    if (!defaultOption) return;

    const input = defaultOption.querySelector('input');
    if (input) {
      input.checked = true;
    }
    this.syncConfirmButtonState();
  }

  onSelectionChange() {
    this.setError('');
    this.syncConfirmButtonState();
  }

  /**
   * Checkout is blocked until prices finish loading and a frequency is selected.
   */
  syncConfirmButtonState() {
    if (!this.confirmButton) return;

    // Never override the submitting spinner state from here.
    if (this.confirmButton.classList.contains('is-loading')) return;

    const checked = this.querySelector('input[name="df_purchase_option"]:checked');
    const canCheckout = !!checked && this._isPricingReady && !this._isPricingLoading;

    this.confirmButton.disabled = !canCheckout;
    this.confirmButton.classList.toggle('is-pricing', this._isPricingLoading);

    if (this.confirmLabel) {
      this.confirmLabel.textContent = this._isPricingLoading
        ? 'Calculating…'
        : this._defaultConfirmLabel;
    }
  }

  setPricingLoading(isLoading) {
    this._isPricingLoading = isLoading;
    this._isPricingReady = !isLoading;
    this.classList.toggle('is-pricing', isLoading);
    this.setPricesLoading(isLoading);
    if (isLoading) {
      this.setSubtitleSavePercent(null, { loading: true });
    }
    this.syncConfirmButtonState();
  }

  clearOptionPrices() {
    this.optionEls.forEach((optionEl) => {
      const priceEl = optionEl.querySelector('[data-df-price]');
      if (priceEl) priceEl.innerHTML = '';
      optionEl.classList.remove('has-price', 'is-pricing');
      this.setOptionSaveText(optionEl, null);
    });
    this.setSubtitleSavePercent(null);
  }

  setPricesLoading(isLoading) {
    this.optionEls.forEach((optionEl) => {
      if (optionEl.classList.contains('is-unavailable')) return;
      optionEl.classList.toggle('is-pricing', isLoading);
      const priceEl = optionEl.querySelector('[data-df-price]');
      if (!priceEl) return;
      if (isLoading) {
        priceEl.innerHTML = '<span class="df-option__price-loading">Calculating…</span>';
      }
    });
  }

  setOptionSaveText(optionEl, savePercent) {
    const saveEl = optionEl.querySelector('[data-df-save]');
    if (!saveEl) return;

    if (savePercent != null && savePercent > 0) {
      saveEl.textContent = ` - Save ${savePercent}%`;
      saveEl.hidden = false;
    } else {
      saveEl.textContent = '';
      saveEl.hidden = true;
    }
  }

  setSubtitleSavePercent(savePercent, { loading = false } = {}) {
    const subtitleSave = this.querySelector('[data-df-subtitle-save]');
    const subtitleWrap = this.querySelector('[data-df-subtitle-save-wrap]');
    if (!subtitleSave) return;

    if (loading) {
      subtitleSave.textContent = '…';
      if (subtitleWrap) subtitleWrap.hidden = false;
      return;
    }

    // Fixed 5% subscription save shown in the modal.
    if (savePercent != null && savePercent > 0) {
      subtitleSave.textContent = `${savePercent}%`;
      if (subtitleWrap) subtitleWrap.hidden = false;
    } else {
      subtitleSave.textContent = '';
      if (subtitleWrap) subtitleWrap.hidden = true;
    }
  }

  schedulePricingPrefetch(delay = 50) {
    this._pricingCache = null;
    window.clearTimeout(this._pricingPrefetchTimer);

    this._pricingPrefetchTimer = window.setTimeout(() => {
      // Estimate-only — never mutate the live cart for preview.
      this.computeAvailability();
      this.applyImmediateEstimatedPricing();
    }, delay);
  }

  startPricingLoad() {
    if (this._pricingPromise) return this._pricingPromise;

    this._pricingPromise = this.loadFrequencyPricing().finally(() => {
      this._pricingPromise = null;
    });

    return this._pricingPromise;
  }

  getSubscriptionSavePercent() {
    return DeliveryFrequencyModal.SUBSCRIPTION_SAVE_PERCENT;
  }

  /**
   * Instant estimate: fixed 5% off the one-off cart total.
   * Does NOT touch selling plans / cart — keeps drawer on full (one-off) total.
   * Prefer the higher of modal data-cart-total and checkout data-cart-cost so a
   * leftover subscription discount never becomes the base for another 5% off.
   */
  applyImmediateEstimatedPricing() {
    const savePercent = this.getSubscriptionSavePercent();

    const liveCartCost = parseInt(
      document.querySelector('checkout-button')?.getAttribute('data-cart-cost'),
      10
    );
    const attrTotal = this.getOneOffTotalCents();
    const live = Number.isFinite(liveCartCost) ? liveCartCost : 0;
    // When residual subscription discounts lower live total, attr/original wins.
    // When the cart grew, live is higher and wins.
    const oneOffCents = Math.max(live, attrTotal) || live || attrTotal;
    if (!oneOffCents) return false;

    const subscriptionCents = Math.round(
      oneOffCents * (1 - savePercent / 100)
    );

    this._pricingCache = {
      oneOffCents,
      subscriptionCents,
      compareCents: oneOffCents,
      savePercent,
      estimated: true,
    };

    return this.applyCachedPricing();
  }

  applyCachedPricing() {
    const cache = this._pricingCache;
    if (!cache || cache.oneOffCents == null) return false;

    const liveCartCost = parseInt(
      document.querySelector('checkout-button')?.getAttribute('data-cart-cost'),
      10
    );
    // Only invalidate when the live drawer total is *higher* (cart grew).
    // A lower live total often means leftover subscription plans still on the
    // cart — keep the cached one-off and let ensureOneOffCartState restore it.
    if (
      Number.isFinite(liveCartCost) &&
      liveCartCost > cache.oneOffCents + 1
    ) {
      this._pricingCache = null;
      return this.applyImmediateEstimatedPricing();
    }

    this.optionEls.forEach((optionEl) => {
      if (optionEl.classList.contains('is-unavailable')) return;

      if (optionEl.dataset.dfIsSubscription === 'true') {
        this.renderOptionPrice(optionEl, {
          totalCents: cache.subscriptionCents,
          compareCents: cache.compareCents ?? cache.oneOffCents,
        });
      } else {
        this.renderOptionPrice(optionEl, { totalCents: cache.oneOffCents });
      }
    });
    this.setSubtitleSavePercent(cache.savePercent);
    return true;
  }

  renderOptionPrice(optionEl, { totalCents, compareCents = null } = {}) {
    const priceEl = optionEl.querySelector('[data-df-price]');
    if (!priceEl || totalCents == null) return;

    optionEl.classList.remove('is-pricing');
    optionEl.classList.add('has-price');

    const isSubscription = optionEl.dataset.dfIsSubscription === 'true';
    const showCompare = isSubscription && compareCents != null && compareCents > totalCents;
    const rowParts = [];

    if (showCompare) {
      rowParts.push(`<s class="df-option__price-compare">${this.formatMoney(compareCents)}</s>`);
    }

    rowParts.push(`<span class="df-option__price-current">${this.formatMoney(totalCents)}</span>`);
    priceEl.innerHTML = `<span class="df-option__price-row">${rowParts.join('')}</span>`;

    if (isSubscription) {
      this.setOptionSaveText(optionEl, this.getSubscriptionSavePercent());
    } else {
      this.setOptionSaveText(optionEl, null);
    }
  }

  /**
   * Fixed 5% off one-off total — display only. Selling plans apply on confirm.
   * Does not clear or mutate cart lines.
   */
  async loadFrequencyPricing() {
    const requestId = ++this._pricingRequestId;

    this.setPricingLoading(true);

    const oneOffCents = await this.resolveOneOffTotalCents();
    if (requestId !== this._pricingRequestId) return;

    const savePercent = this.getSubscriptionSavePercent();
    const subscriptionCents = Math.round(oneOffCents * (1 - savePercent / 100));

    this._pricingCache = {
      oneOffCents,
      subscriptionCents,
      compareCents: oneOffCents,
      savePercent,
      estimated: true,
    };

    this.applyCachedPricing();
    this.setPricingLoading(false);
  }

  /**
   * Returns every line item in the cart paired with its .selling-plan-options
   * container. The container's data-selling-plan-1-week-id /
   * data-selling-plan-2-weeks-id attributes tell us which subscription
   * frequencies that item offers (matching cart-drawer.js's ID-based mapping).
   */
  collectCartItems() {
    const itemNodes = Array.from(document.querySelectorAll('cart-drawer .cart-item'));

    return itemNodes.map((node) => ({
      title: this.itemLabel(node),
      planContainer: node.querySelector('.selling-plan-options'),
    }));
  }

  /**
   * An item supports a frequency when the matching selling-plan-id attribute is
   * present and non-empty. One-off (no planAttr) is always supported.
   */
  itemSupports(item, planAttr) {
    if (!planAttr) return true;
    const id = item.planContainer?.getAttribute(planAttr);
    return !!(id && id.trim());
  }

  /**
   * Builds a display label for a cart line, e.g. "Protein Bowl ($12.99)". The
   * price disambiguates products that share a name but differ in price. Falls
   * back to just the name (or "An item") when no price is rendered.
   */
  itemLabel(node) {
    const name = node.querySelector('.cart-item__name')?.textContent?.trim() || 'An item';
    const priceEl = node.querySelector('.cart-item__final-price, .cart-item__price-display');
    const price = priceEl?.textContent?.trim().replace(/\s+/g, ' ');
    return price ? `${name} (${price})` : name;
  }

  computeAvailability() {
    const items = this.collectCartItems();

    this.optionEls.forEach((optionEl) => {
      const planAttr = optionEl.dataset.planIdAttr || '';

      // One-off (no plan attribute) is always available — anything can ship once.
      if (!planAttr || items.length === 0) {
        this.setOptionState(optionEl, true);
        return;
      }

      const unsupported = items
        .filter((item) => !this.itemSupports(item, planAttr))
        .map((item) => item.title);

      if (unsupported.length === 0) {
        this.setOptionState(optionEl, true);
      } else if (unsupported.length === items.length) {
        this.setOptionState(optionEl, false, 'None of your items can be delivered at this frequency.');
      } else {
        this.setOptionState(optionEl, false, `Not available for ${this.formatNames(unsupported)}.`);
      }
    });
  }

  setOptionState(optionEl, available, message = '') {
    const input = optionEl.querySelector('input');
    const note = optionEl.querySelector('.df-option__note');

    if (available) {
      optionEl.classList.remove('is-unavailable');
      if (input) input.disabled = false;
      if (note) {
        note.hidden = true;
        note.textContent = '';
      }
    } else {
      optionEl.classList.add('is-unavailable');
      if (input) {
        input.checked = false;
        input.disabled = true;
      }
      if (note) {
        note.textContent = message;
        note.hidden = !message;
      }
    }
  }

  formatNames(names) {
    const unique = [...new Set(names)];
    if (unique.length === 1) return unique[0];
    if (unique.length === 2) return `${unique[0]} and ${unique[1]}`;
    return `${unique.slice(0, -1).join(', ')}, and ${unique[unique.length - 1]}`;
  }

  getSelectedFrequency() {
    const checked = this.querySelector('input[name="df_purchase_option"]:checked');
    if (!checked) return null;
    return {
      value: checked.value,
      readable: checked.dataset.label || checked.value || 'One-off',
    };
  }

  setError(message = '') {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = !message;
  }

  setConfirmLoading(isLoading) {
    if (!this.confirmButton) return;

    if (isLoading) {
      this.confirmButton.disabled = true;
      this.confirmButton.classList.add('is-loading');
      this.confirmButton.classList.remove('is-pricing');
      if (this.confirmLabel) {
        this.confirmLabel.textContent = this._defaultConfirmLabel;
      }
    } else {
      this.confirmButton.classList.remove('is-loading');
      this.syncConfirmButtonState();
    }
  }

  async onConfirm() {
    if (this._isUpdatingFrequency) return;

    if (this._isPricingLoading || !this._isPricingReady) {
      this.setError('Please wait while we calculate your subscription price.');
      return;
    }

    const selected = this.getSelectedFrequency();
    if (!selected) {
      this.setError('Please choose a delivery frequency to continue.');
      return;
    }

    this.setError('');
    this.setConfirmLoading(true);
    this.setUpdatingGuard(true);

    const cartDrawer = document.querySelector('cart-drawer');

    // One bulk plan apply (GraphQL) then submit — skip redundant line-id + Ajax loops.
    if (cartDrawer && typeof cartDrawer.applySelectedFrequencyToCart === 'function') {
      let synced;
      try {
        synced = await cartDrawer.applySelectedFrequencyToCart(selected.value);
      } catch (err) {
        console.error('cdebug df-modal sync error', err);
        this.setUpdatingGuard(false);
        this.setConfirmLoading(false);
        this.setError('Something went wrong while updating your order. Please try again in a moment.');
        return;
      }

      if (!synced) {
        this.setUpdatingGuard(false);
        this.setConfirmLoading(false);
        this.setError("We couldn't apply your delivery frequency. Please try again in a moment.");
        return;
      }
    }

    this.submitCheckout();
  }

  async ensureCartLineIds(cartDrawer) {
    if (typeof cartDrawer.getCartLineIds !== 'function') return;
    const itemNodes = Array.from(document.querySelectorAll('cart-drawer .cart-item'));
    const missingLineIds = itemNodes.some((node) => !node.getAttribute('data-line-id'));
    const noLineItems = !Array.isArray(cartDrawer.lineItems) || cartDrawer.lineItems.length === 0;
    if (missingLineIds || noLineItems) {
      await cartDrawer.getCartLineIds();
    }
  }

  submitCheckout() {
    const form = document.querySelector('#CartDrawer-Form');
    if (!form) {
      this.setUpdatingGuard(false);
      this.setConfirmLoading(false);
      this.setError('We hit a snag starting checkout. Please refresh the page and try again.');
      return;
    }
    form.submit();
  }
}

customElements.define('delivery-frequency-modal', DeliveryFrequencyModal);

//tabs in account page
const container = document.querySelector(".account #customer-account");

if (container) {
  const contentTabs = container.querySelectorAll("[data-account-details]");
  const customerDetailsTabs = container.querySelectorAll(
    ".customer-data-buttons button"
  );

  function showTab(selectedValue) {
    contentTabs.forEach((tab) => {
      tab.classList.add("hidden");
    });

    const selectedEle = container.querySelector(
      `[data-account-details="${selectedValue}"]`
    );
    selectedEle.classList.remove("hidden");

    customerDetailsTabs.forEach((button) => {
      button.classList.toggle(
        "active",
        button.getAttribute("data-button-details") === selectedValue
      );
    });
  }

  contentTabs.forEach((tab, index) => {
    tab.classList.add("hidden");

    if (index === 0) {
      tab.classList.remove("hidden");
    }
  });

  Array.from(customerDetailsTabs)[0].classList.add("active");

  customerDetailsTabs.forEach((button) => {
    button.addEventListener("click", () => {
      const selectedValue = button.getAttribute("data-button-details");
      showTab(selectedValue);
    });
  });
}

//back button product page
function goToReferrer() {
  var referrer = document.referrer;
  // Check if there is a referrer
  if (referrer !== "") {
    // Navigate to the referrer URL
    window.location.href = referrer;
  }
}


const MENU_COLLECTION_PATH = '/collections/full-menu';

function openCartDrawerFromUrl() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has('openCartDrawer') || params.get('openCartDrawer') !== 'true') return;

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  cartDrawer.open();
  const cleanPath = window.location.pathname.startsWith('/collections/')
    ? window.location.pathname
    : MENU_COLLECTION_PATH;
  history.replaceState({}, '', cleanPath);
}

document.addEventListener('DOMContentLoaded', function () {
  const currentPath = window.location.pathname;

  if (currentPath.includes('/cart')) {
    window.location.href = `${MENU_COLLECTION_PATH}?openCartDrawer=true`;
    return;
  }

  if (currentPath === '/collections/all') {
    const params = new URLSearchParams(window.location.search);
    window.location.href = `${MENU_COLLECTION_PATH}${params.toString() ? `?${params.toString()}` : ''}`;
    return;
  }

  openCartDrawerFromUrl();
});


(function(){
  const links = Array.from(document.querySelectorAll('[data-with-anchor-link]'))


  links.forEach((link) => {
      link.addEventListener('click', (e) => {
        var close = document.querySelector('summary.header__icon')
        close.click();
      });

  });

})();
